import {toCamelCase} from 'case-converter'

export const state = () => ({
  pricesColocation: []
})

export const mutations = {
  setColocationPrices(state, value) {
    state.pricesColocation = value
  }
}

export const actions = {
  async fetchColocationPrices({commit}) {
    let allTariffs
    const pricesMain = []
    let additionalPrices = []
    let processError
    let locations
    const locale = this.$i18n.locale

    //Получаем все основные тарифы
    await fetch('https://selectel.ru/api/servers/v2/service/colocation', {
      method: 'GET'
    }).then(res => res.json())
      .then(res => allTariffs = toCamelCase(res.result))
      .catch(err => processError = err)

    //Проходимся по всем тарифам
    for (let i = 0; i < allTariffs.length; i++) {
      let locInfo

      //Получаем подробные данные каждого тарифа
      await fetch(`https://selectel.ru/api/servers/v2/service/colocation/${allTariffs[i].uuid}`, {
        method: 'GET',
        headers: {
          locale
        }
      }).then(res => res.json())
        .then(res => locInfo = toCamelCase(res))
        .catch(err => processError = err)

      //Пушим в массив с основными ценами
      pricesMain.push({
        uuid: locInfo.result.uuid,

        name: locInfo.result.name,

        prices: {
          rub: locInfo.result.priceCollection.rub.month,
          eur: locInfo.result.priceCollection.eur.month,
          usd: locInfo.result.priceCollection.usd.month
        },

        locations: locInfo.result.available.slice()
      })

      //Проходимся по дополнительным ценам
      for (let j = 0; j < locInfo.result.addition.length; j++) {
        const currentPrice = additionalPrices
          .find(price => price.uuid === locInfo.result.addition[j].uuid)

        //Если такой цены еще не было, то пушим в массив с доп ценами
        if (!currentPrice) {
          additionalPrices.push({
            uuid: locInfo.result.addition[j].uuid,

            name: locInfo.result.addition[j].name,

            prices: {
              rub: locInfo.result.addition[j].priceCollection.rub.month,
              eur: locInfo.result.addition[j].priceCollection.eur.month,
              usd: locInfo.result.addition[j].priceCollection.usd.month
            },

            locations: locInfo.result.available.slice()
          })

          //Если цена была, то проверям добавляется ли локация к этой цене и пушим её
        } else {
          for (let x = 0; x < locInfo.result.available.length; x++) {
            if (!currentPrice.locations
              .find(price => price.location === locInfo.result.available[x].location)) {
              currentPrice.locations.push(locInfo.result.available[x])
            }
          }
        }
      }
    }

    additionalPrices = additionalPrices.sort(((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1

      return 0
    }))

    //Получаем все локации
    await fetch('https://selectel.ru/api/servers/v2/location', {
      method: 'GET'
    }).then(res => res.json())
      .then(res => locations = toCamelCase(res.result))
      .catch(err => processError = err)

    //Оставляем только локации которые использовались в ценах
    locations = locations
      .filter(loc => pricesMain
        .find(price => price.locations
          .find(l => l.location === loc.uuid)))
      .sort(((a, b) => {
        if (a.description < b.description) return -1
        if (a.description > b.description) return 1

        return 0
      }))
    commit('setColocationPrices', [pricesMain, additionalPrices, locations])

    return pricesMain && additionalPrices && locations
      ? Promise.resolve([pricesMain, additionalPrices, locations])
      : Promise.reject(processError)
  }
}

export const getters = {
  getColocationPrices(state) {
    return state.pricesColocation
  }
}